import React from "react"

import {IUser} from "@backend/types"
import {defaultProfileImg} from "../../../constants"


type UserInfoProps = {
    user: IUser
}

export function UserInfo({user}: UserInfoProps) {
    const {publicInfo, privateInfo} = user || {}
    return <div className="flex">
        <img className="h-10 w-10 rounded-full" src={publicInfo?.profilePhoto || defaultProfileImg} alt=""/>
        <div className="ml-3 flex flex-col justify-center">
            <span className="text-sm font-medium text-gray-900">{publicInfo?.displayName}</span>
            {privateInfo?.email &&
              <span className="text-sm text-gray-500">{privateInfo?.email}</span>}
        </div>
    </div>
}